/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Docs} from 'components/layout';
import {getIntegrations} from 'api/get-integrations';
import {getExtensions} from 'api/get-extensions';
import {Warning, Tip, Info, WhitelistDetails} from 'ui';
export const lastUpdatedDate = new Date(1669593600000);
export async function getStaticProps() {
  const integrations = await getIntegrations();
  const extensions = await getExtensions();
  return {
    props: {
      ...integrations,
      extensions,
      meta: {
        title: null,
        description: null,
        lastUpdatedDate: "Mon Nov 28 2022 00:00:00 GMT+0000 (Coordinated Universal Time)",
        slug: "qualtrics",
        type: "destination",
        icon: null,
        toc: [{
          "value": "Overview",
          "depth": 0,
          "id": "overview"
        }, {
          "value": "Setup",
          "depth": 0,
          "id": "setup"
        }, {
          "value": "Sending contacts",
          "depth": 0,
          "id": "sending-contacts"
        }, {
          "value": "Sync status",
          "depth": 0,
          "id": "sync-status"
        }, {
          "value": "Tips and troubleshooting",
          "depth": 0,
          "id": "tips-and-troubleshooting"
        }, {
          "value": "Common errors",
          "depth": 1,
          "id": "common-errors"
        }, {
          "value": "Live debugger",
          "depth": 1,
          "id": "live-debugger"
        }, {
          "value": "Sync alerts",
          "depth": 1,
          "id": "sync-alerts"
        }]
      }
    },
    revalidate: 60
  };
}
const MDXLayout = ({children, ...props}) => _jsx(Docs, Object.assign({}, props, {
  children: children
}));
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h2: "h2",
      p: "p",
      img: "img",
      h3: "h3"
    }, _provideComponents(), props.components), {NoCommonErrors, LiveDebugger, SyncAlerts} = _components;
    if (!LiveDebugger) _missingMdxReference("LiveDebugger", true);
    if (!NoCommonErrors) _missingMdxReference("NoCommonErrors", true);
    if (!SyncAlerts) _missingMdxReference("SyncAlerts", true);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.h2, {
        id: "overview",
        children: "Overview"
      }), "\n", _jsx(_components.p, {
        children: "This integration allows you to import contacts to Qualtrics XM Directory using\nimport automations. Hightouch posts CSV files to the Qualtrics file service\nendpoint for your automation. After the sync, Qualtrics will asynchronously\nprocess the files."
      }), "\n", _jsx(_components.h2, {
        id: "setup",
        children: "Setup"
      }), "\n", _jsx(_components.p, {
        children: "After selecting Qualtrics from our Destinations catalog, you will be asked to\nprovide your Qualtrics data center ID and API token."
      }), "\n", _jsxs(_components.p, {
        children: ["Both of these can be found in the Qualtrics console under Account Settings >\nQualtrics IDs.\n", _jsx(_components.img, {
          src: "destinations/destination-qualtrics-data-center.png",
          alt: ""
        })]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-qualtrics-api-token.png",
          alt: ""
        })
      }), "\n", _jsx(_components.h2, {
        id: "sending-contacts",
        children: "Sending contacts"
      }), "\n", _jsx(_components.p, {
        children: "Hightouch supports syncing contacts to Qualtrics XM Directory. Rows will be\nsynced when they are added or changed. Rows that are removed from your model\nwill be ignored."
      }), "\n", _jsx(_components.p, {
        children: "Hightouch sends your contacts to Qualtrics in batches of 10,000 rows. Each batch\nis posted with a unique filename, based on the current time."
      }), "\n", _jsx(_components.h2, {
        id: "sync-status",
        children: "Sync status"
      }), "\n", _jsx(_components.p, {
        children: "Because Qualtrics asynchronously processes the files on the automation's\nschedule, Hightouch only shows whether the files were posted to Qualtrics\nsuccessfully. Hightouch doesn't wait for Qualtrics to process the files."
      }), "\n", _jsx(_components.p, {
        children: "We recommend that you enable email notifications in Qualtrics so that you know\nwhen Qualtrics is done processing the files."
      }), "\n", _jsx(_components.h2, {
        id: "tips-and-troubleshooting",
        children: "Tips and troubleshooting"
      }), "\n", _jsx(_components.h3, {
        id: "common-errors",
        children: "Common errors"
      }), "\n", _jsx(NoCommonErrors, {}), "\n", _jsx(_components.h3, {
        id: "live-debugger",
        children: "Live debugger"
      }), "\n", _jsx(LiveDebugger, {}), "\n", _jsx(_components.h3, {
        id: "sync-alerts",
        children: "Sync alerts"
      }), "\n", _jsx(SyncAlerts, {})]
    });
  }
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
